import { useNavigate } from "react-router-dom";
import { Lightbulb, ArrowRight, Clock } from "lucide-react";
import { Badges, DifficultyPill } from "./Badges";
import { LogoBadge } from "./LogoBadge";

export const BusinessCard = ({ business, onInspire, index = 0 }) => {
  const navigate = useNavigate();

  return (
    <div
      className="group relative bg-white rounded-2xl p-7 border border-gray-100 shadow-[0_4px_20px_rgb(0,0,0,0.03)] hover:shadow-[0_16px_40px_rgb(0,0,0,0.08)] hover:-translate-y-1 transition-all duration-300 flex flex-col animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
      data-testid={`business-card-${business.id}`}
    >
      <button
        onClick={(e) => {
          e.stopPropagation();
          onInspire(business);
        }}
        className="absolute top-6 right-6 w-10 h-10 rounded-full bg-[#F7F7F7] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-white flex items-center justify-center transition-colors duration-300 z-10"
        data-testid={`business-card-inspire-btn-${business.id}`}
        title="Inspiration"
      >
        <Lightbulb size={18} />
      </button>

      <LogoBadge size="w-14 h-14" rounded="rounded-2xl" className="mb-5" />

      <h3 className="font-display text-xl font-semibold text-[#0F0F0F] mb-1">{business.title}</h3>
      <p className="text-sm font-medium text-[#D4AF37] mb-3">{business.category_name}</p>
      {business.summary && (
        <p className="text-sm text-[#687280] leading-relaxed mb-5 line-clamp-3">{business.summary}</p>
      )}

      {business.tags?.length > 0 && <Badges items={business.tags.slice(0, 3)} className="mb-5" />}

      <div className="flex items-center gap-4 mb-6 text-xs text-[#687280]">
        {business.difficulty && <DifficultyPill level={business.difficulty} />}
        {business.buildTime && (
          <span className="inline-flex items-center gap-1.5">
            <Clock size={13} /> {business.buildTime}
          </span>
        )}
      </div>

      <button
        onClick={() => navigate(`/business/${business.id}`)}
        className="mt-auto flex items-center gap-2 text-sm font-semibold text-[#0F0F0F] hover:text-[#D4AF37] transition-colors duration-300 group/btn"
        data-testid={`business-card-view-btn-${business.id}`}
      >
        View Business
        <ArrowRight size={16} className="transition-transform duration-300 group-hover/btn:translate-x-1" />
      </button>
    </div>
  );
};
